module.exports = __webpack_public_path__ + "static/media/pic10.e6ac3739.jpg";